/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.offerings.controllers', [
  'ui.router',
  'ui.bootstrap',
  'ui.sortable',
  'acme.common.service.api',
  'acme.common.service.config',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.service.posConfig',
  'acme.common.service.permissions',
  'acme.common.factory.notice',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.view.application.pos.create.images.removeModal.controllers',
  'acme.view.application.membership.offerings.modals.remove.controllers',
  'agGrid'
])

.controller('MembershipOfferingsController', ['$scope', '$state', '$uibModal', '$timeout', 'ApiService', 'HelpersService', 'ValidateService', 'PermissionsService', 'ConfigService', 'PosConfigService', 'GridStateFactory', 'GridDefinitionFactory', 'NoticeFactory', function($scope, $state, $uibModal, $timeout, ApiService, HelpersService, ValidateService, PermissionsService, ConfigService, PosConfigService, GridStateFactory, GridDefinitionFactory, NoticeFactory) {

    $scope.membershipOfferings = {

      model: [],

      searchQuery: '',
      isLoaded: false,

      viewId: '',
      gridName: $state.current.name+'.grid0',

      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),

      notice: new NoticeFactory(),

      optionsOverride: {
        enableRowSelection: false,
        multiSelect: false,
        noUnselect: false,
        data: 'membershipOfferings.model',
        appScopeProvider: {
          remove: function(id) {
            $scope.membershipOfferings.remove(id);
          },
          onDblClick: function(row) {
            $scope.membershipOfferings.onGridDoubleClick(row);
          },
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.membershipOfferings.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDataGridSortChange: function(grid, columns) {
            $scope.membershipOfferings.onDataGridSortChange(grid, columns);
          }
        },
        columnDefs: [
          {
            field: 'id',
            displayName: 'Id',
            visible: false
          },
          {
            field: 'name',
            displayName: 'Name',
            sort: {
              direction: 'asc'
            }
          },
          {
            field: 'startDate',
            displayName: 'Start Date',
            visible: false
          },
          {
            field: 'endDate',
            displayName: 'End Date'
          },
          {
            field: 'displayDuration',
            displayName: 'Duration'
          }
        ]
      },

      init: function() {

        this.viewId = $state.current.name;

        if ($state.params) {
          if ($state.params.categoryId) {
            this.categoryId = $state.params.categoryId;
          }
        }

        if (PermissionsService.check('MEMBERSHIP_OFFERING_DELETE')) {
          this.optionsOverride.columnDefs.push({
            field: 'remove',
            displayName: 'Remove',
            width: 80,
            enableHiding: false,
            enableSorting: false,
            onCellNavClick: function(row, col) {
              $scope.membershipOfferings.remove(row.entity.id);
            },
            cellTemplate: '<div class="ui-grid-cell-contents text-center"><a data-ng-click="grid.appScope.remove(row.entity.id)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>'
          });
        }

        if (PermissionsService.check('MEMBERSHIP_OFFERING_UPDATE')) {
          this.optionsOverride.columnDefs.unshift({
            field: 'edit',
            displayName: 'Edit',
            enableHiding: false,
            enableSorting: false,
            width: 50,
            onCellNavClick: function(row, col) {
              $scope.membershipOfferings.onGridDoubleClick(row);
            },
            cellTemplate: '<div class="ui-grid-cell-contents text-center"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>'
          });
        }

        this.gridDefinition.init(this.gridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);
        $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);

        $scope.$on('MembershipOfferings::Update', this.onMembershipOfferingsUpdate);

      },

      initData: function() {
        var self = $scope.membershipOfferings, props = self.gridDefinition.getGridState();
        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);

        self.getOfferings();
      },

      getOfferings: function() {
        var props = this.gridState.getGridState();
        props.salesChannels = 'online';
        props.isPublished = '0';
        props.categoryId = $state.params.categoryId;
        ApiService.membership.offerings.list(props).then(this.success.getOfferings, this.error.getOfferings);
      },

      create: function() {
        var self = $scope.membershipOfferings;

        this.notice.hideErrorMessages();
        this.notice.hideSuccessMessages();
      },

      findOfferings: function(id) {

        var i, ii,
          r = false,
          self = $scope.membershipOfferings;

        for (i=0,ii=self.model.length;i<ii;i++) {
          if (self.model[i].id === id) {
            r = {
              offering: self.model[i],
              index: i
            };
            break;
          }
        }

        return r;

      },

      remove: function(id) {
        var self = $scope.membershipOfferings,
            found = self.findOfferings(id);

        if (found) {
          self.removeModal = $uibModal.open({
            templateUrl: 'views/application/views/membership/offerings/modals/remove/remove.tpl.html',
            size: 'md',
            controller: 'MembershipOfferingsModalsRemoveController',
            resolve: {
              currentOffering: function () {
                return found.offering;
              }
            }
          });

          self.removeModal.result.then(function () {
            ApiService.membership.offerings.remove({
              categoryId: $state.params.categoryId,
              offeringId: found.offering.id
            }).then(self.success.remove, self.error.remove);
          }, function (message) {
            // Invoked when modal completes with dismiss(params)
          });
        }

      },

      search: function() {
        this.gridState.setPropertyValue('search', this.searchQuery);
        $scope.$broadcast('DataGrid::Search', {name: this.gridName});
      },

      process: function(model) {
        var i, ii;

        for (i=0,ii=model.length;i<ii;i++) {
          model[i].displayDuration = parseInt(model[i].duration / 12, 10) + ' years ' + (model[i].duration % 12) + ' months';
        }

        return model;
      },

      success: {

        init: function(response) {},

        getOfferings: function(response) {
          var self = $scope.membershipOfferings;

          self.model = self.process(response.data.payload.list);
          self.gridDefinition.options.totalItems = response.data.payload.pagination.count;
          self.gridDefinition.isLoaded = true;
          self.isLoaded = true;
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {
              name: self.gridDefinition.options.gridName,
              datasetLength: self.model.length
            });
          }, 10);
        },

        remove: function(response) {
          var self = $scope.membershipOfferings;
          $scope.$emit('MembershipOfferings::Remove');
          self.search();
        }

      },

      error: {
        init: function(response) {},
        getOfferings: function(response) {
          var self = $scope.membershipOfferings;

          self.gridDefinition.isLoaded = true;
          self.isLoaded = true;
        },
        remove: function(response) {
          $scope.$emit('MembershipOfferings::Error', response);
        }
      },

      onMembershipOfferingsUpdate: function(e, data) {
        var self = $scope.membershipOfferings;
        self.model = data.offerings;
      },

      onGridDoubleClick: function(item) {
        if (PermissionsService.check('MEMBERSHIP_OFFERING_UPDATE')) {
          $state.go('application.membership.offerings.edit', { categoryId: $state.params.categoryId, offeringId: item.entity.id });
        }
      },

      onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
        var self = $scope.membershipOfferings;
        self.gridState.updateGridState(newPage, pageSize);
        if (sortField) {
          self.gridState.updateGridState(null, null, sortField, null);
        }
        if (sortDirection) {
          self.gridState.updateGridState(null, null, null, sortDirection);
        }

        self.getOfferings();
      },

      onDataGridSortChange: function(grid, columns, page) {
        var self = $scope.membershipOfferings,
          data = columns[0];
        self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);

        self.getOfferings();
      },

      onDataGridSelectionChange: function(row, e) {}
      
    };

    $scope.membershipOfferings.init();

}]);